// --- START i18n configuration ---
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import ICU from 'i18next-icu';

// Initialize i18next with react-i18next, language detection, and ICU support
i18n
  .use(HttpBackend) // Load translations from public/locales
  .use(ICU) // ICU formatting for advanced plurals and variables
  .use(LanguageDetector) // Detect user language from browser
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    // Fallback language if detection fails or translation missing
    fallbackLng: 'pt-PT',
    
    // Supported languages
    supportedLngs: ['en', 'pt-PT', 'pt'],
    
    // Don't load a fallback namespace
    fallbackNS: false,
    
    // Default namespace
    defaultNS: 'common',
    
    // Available namespaces
    ns: ['common', 'nav', 'footer', 'account', 'accountNav', 'upload', 'cart', 'checkout', 'contact', 'profile', 'orders', 'company', 'settings', 'marketing', 'catalog'],
    
    // Language detection options
    detection: {
      // Order of detection methods - only localStorage, no navigator fallback
      order: ['localStorage'],
      
      // Cache user language in localStorage
      caches: ['localStorage'],
      
      // localStorage key
      lookupLocalStorage: 'i18nextLng',
    },
    
    // Language code normalization - map 'pt' to 'pt-PT'
    load: 'currentOnly',
    nonExplicitSupportedLngs: true,
    
    // React-i18next options
    react: {
      useSuspense: true, // Use Suspense for loading translations
    },
    
    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // Backend options - load from public/locales
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    // Debug in development
    debug: import.meta.env.DEV,
  });

export default i18n;
// --- END i18n configuration ---
